import {
  EResetPasswordCasesDB,
  EResetPasswordCasesUI,
  TConfirmSignUpDB,
  TConfirmSignUpUI,
  TResetPasswordCasesDB,
  TResetPasswordCasesUI,
  TResetPasswordDB,
  TResetPasswordFormDB,
  TResetPasswordFormUI,
  TResetPasswordUI,
  TSetPasswordFormDB,
  TSetPasswordFormUI,
  TSignInAmplifyDB,
  TSignInAmplifyUI,
  TSignupDataDB,
  TSignupDataUI,
} from 'data/types/auth.types';
import { TAuthConverter, TCreateConverter, TFetchConverter } from '../types/converter.types';

export const signupDataConverter: TCreateConverter<TSignupDataUI, TSignupDataDB> = {
  toDb: ({ businessName, fullName, password, email, phone }) => {
    return {
      businessName,
      name: fullName,
      password,
      email: email.trim(),
      phone: phone ? `+${phone}` : undefined,
    };
  },
};

export const signInAmplifyConverter: TCreateConverter<TSignInAmplifyUI, TSignInAmplifyDB> = {
  toDb: ({ email, password }) => {
    return { username: email.trim(), password };
  },
};

export const resetPasswordCasesConverter: TAuthConverter<
  TResetPasswordCasesUI,
  TResetPasswordCasesDB,
  EResetPasswordCasesUI,
  EResetPasswordCasesDB
> = {
  toDb: ({ email }) => {
    return {
      username: email.trim(),
    };
  },
  fromDb: (data) => {
    const dataMapper: {
      [key in EResetPasswordCasesDB]: EResetPasswordCasesUI;
    } = {
      [EResetPasswordCasesDB.RESEND_INVITATION]: EResetPasswordCasesUI.RESEND_INVITATION,
      [EResetPasswordCasesDB.RESENT_CODE]: EResetPasswordCasesUI.RESENT_CODE,
      [EResetPasswordCasesDB.RESENT_PASSWORD]: EResetPasswordCasesUI.RESENT_PASSWORD,
    };
    return dataMapper[data];
  },
};
export const resetPasswordConverter: TFetchConverter<TResetPasswordUI, TResetPasswordDB> = {
  fromDb: (data) => {
    return {
      passwordResendStatus: resetPasswordCasesConverter.fromDb(data.passwordResendStatus),
      isAdmin: data.admin,
    };
  },
};
export const resetPasswordFormConverter: TCreateConverter<TResetPasswordFormUI, TResetPasswordFormDB> = {
  toDb: ({ email, password, code }) => {
    return { username: email.trim(), password, code: code.trim() };
  },
};

export const confirmSIgnUpConverter: TCreateConverter<TConfirmSignUpUI, TConfirmSignUpDB> = {
  toDb: ({ email, code }) => {
    return { username: email.trim(), code: code.trim() };
  },
};

export const setNewPasswordConverter: TCreateConverter<TSetPasswordFormUI, TSetPasswordFormDB> = {
  toDb: ({ password, email, temporaryPassword }) => {
    return { temporaryPassword, username: email.trim(), newPassword: password };
  },
};
